import { padToLength } from './stringUtils';

export const nyaAvenyDBSettingsValueName = 'NA_Values';
export const dbSettingsInnehallValueName = 'vtInnehall';

export const padRoutineId = (routineId: number) => {
  return 'RO' + padToLength(routineId.toString(), 10, '0');
};
